export const leagueOptions = [
  { value: 100, label: "Первая лига" },
  { value: 200, label: "Лига 2А" },
  { value: 300, label: "Лига 2Б" },
];

export const leagueMap = leagueOptions.reduce<Record<number, string>>(
  (acc, { value, label }) => {
    acc[value] = label;
    return acc;
  },
  {} as Record<number, string>
);
